/**
 * defa.views.UnitSettingsBluetoothPanel
 * A settings panel for bluetooth units.
 * @version 1.2.0
 */
import Form from 'scripts/poppet/form';
import template from 'templates/unitSettingsBluetoothPanel.jst.html'

const selectors = {
	buttonUpgrade: '[data-click=bluetooth-upgrade]',
	buttonDelete : '[data-click=bluetooth-delete]',
	buttonOpen   : '[data-click=bluetooth-open]',
};

const UnitSettingsBluetoothPanel = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	ui: {
		upgrade: selectors.buttonUpgrade,
		delete : selectors.buttonDelete,
		open   : selectors.buttonOpen,
	},
	
	events: {
		'click @ui.upgrade': 'onClickUpgrade',
		'click @ui.delete' : 'onClickDelete',
		'click @ui.open'   : 'onClickOpen',
	},
	
	modelEvents: {
		'change': 'render',
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when the end user clicks the open button.
	 * @void
	 */
	onClickOpen: function () {
		this.trigger( 'open', this );
	},
	
	/**
	 * Triggers when the end user clicks the delete button.
	 * @void
	 */
	onClickDelete: function () {
		this.trigger( 'nav', 'unit:delete', [ this.model.get( 'id' ) ] );
	},
	
	/**
	 * Triggers when the end user clicks the update button.
	 * @void
	 */
	onClickUpgrade: function () {
		this.trigger( 'upgrade', this );
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default UnitSettingsBluetoothPanel;